import { QuestionViewPropsFor } from '@/components/question/view/types';
import { QuestionTypeEnum } from '@/models/Question';

export function useWritingAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.WRITING>,
) {
  const { mode } = props;
  const onChange = props.mode === 'answering' ? props.onChange : undefined;

  const disabled = mode !== 'answering';

  const handleChange = (value: string) => {
    onChange?.(value || null);
  };

  return { handleChange, disabled };
}
